import React from "react"
import { styled } from "styled-components"
import branding, { EventCloudProduct } from "../../branding/branding"

interface EventCloudProductsPickerProps {
    selectedOption: EventCloudProduct | null
    setSelectedOption: (option: EventCloudProduct) => void
}

const EventCloudProductsPicker: React.FC<EventCloudProductsPickerProps> = ({ selectedOption, setSelectedOption }) => {
    const brandingConfiguration = branding.configuration.eventCloudProducts

    function getEventCloudProductName(option: EventCloudProduct) {
        switch (option) {
            case EventCloudProduct.EVENT_GUIDE:
                return brandingConfiguration.nameEventGuide
            case EventCloudProduct.MOBILE_GUIDE:
                return brandingConfiguration.nameMobileGuide
            case EventCloudProduct.WEB_WIDGETS:
                return brandingConfiguration.nameWebWidgets
            default:
                return ""
        }
    }

    return (
        <div>
            <Title>{brandingConfiguration.titleSwitcher}</Title>
            <Options>
                {brandingConfiguration.list.map((option) => {
                    return (
                        <Option
                            key={option}
                            selected={option.toString() === selectedOption?.toString()}
                            onClick={() => setSelectedOption(option)}
                        >
                            {getEventCloudProductName(option)}
                        </Option>
                    )
                })}
            </Options>
        </div>
    )
}

export default EventCloudProductsPicker

const Title = styled.div`
    color: #727272;
    font-size: 16px;
    line-height: 21px;
    padding-left: 1rem;
`

const Options = styled.div`
    padding-top: 1rem;
`

const Option = styled.div<{ selected: boolean }>`
    font-size: 16px;
    padding: 1rem 0px 1rem 2rem;
    color: ${(props) => (props.selected ? branding.configuration.maincolor : "#202428")};
    background-color: ${(props) => (props.selected ? "#f0f0f0" : "transparent")};
    border-left: ${(props) => (props.selected ? `3px solid ${branding.configuration.maincolor}` : "none")};
    cursor: pointer;
`
